import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import Heroimg2 from '../components/Heroimg2'
import NewsPart from '../components/NewsPart'
import { Helmet } from 'react-helmet-async'



const News = () => {
    return (
      <>
      <Helmet>
      <title>News</title>
      <meta name='description' content={"'What's trending in the world today'"}/>
      <link rel='canonical' href='' />
    </Helmet>

      <div>
        <Navbar />
        <Heroimg2 heading="NEWS." text="What's trending?" />
        <NewsPart />
        <Footer />
      </div>
      </>
    )
  }
  
  export default News